import { Match, MatchType, useMatchParams, useRouterParams } from "@cdv/jazz-ui";
import { ReactElement } from "react";
import { Resource } from "../utils";

export default function ContentShow(): ReactElement {
  const { id } = useRouterParams();
  return <Match type={MatchType.View} params={{ resource: Resource.Info, name: id }} />;
}
